export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"

export const LOGO_URL = "https://img.freepik.com/premium-vector/online-food-app-icon-food-shop-location-logo-also-online-resturent-location-template_608547-155.jpg"

export const MENU_API_BASE = "https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true"

export const SWIGGY_API_ENDPOINT = "/api/swiggy"
export const MENU_API_ENDPOINT = "/api/menu"

export const SWIGGY_DIRECT_API = "https://www.swiggy.com/dapi/restaurants/list/v5"